import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, NgZone, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { CarrouselStoreService, NavDisplayConfig } from '@ecm/carrousel';
import { EnvironmentService, UaService } from '@ecm/consumer';
import { EcmDispatcherModule } from '@ecm/dispatcher';
import { AbstractAppComponent } from '@ecm/ecm/lib/components/abstract-app.component';
import { BrandService, ElcosService, ErrorPageService, RouterService } from '@ecm/router';
import { SmartbannerStoreService } from '@ecm/smartbanner';
import { KenobiService } from '@ecm/tracker';

@Component({
    selector: 'ecm-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent extends AbstractAppComponent implements OnInit {
    /**
     * Do we show sticky Menu
     * @type {boolean}
     */
    public showMenuBar = true;

    public isSmartBannerDisplayed$ = this.smartbannerStoreService.isDisplayed$;

    public navConfig$: Observable<NavDisplayConfig>;

    public isXlScreen$: Observable<boolean>;

    public constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected renderer: Renderer2,
        protected router: Router,
        protected routerService: RouterService,
        protected smartbannerStoreService: SmartbannerStoreService,
        protected elcosService: ElcosService,
        protected uaService: UaService,
        protected environmentService: EnvironmentService,
        protected kenobiService: KenobiService,
        protected carrouselStoreService: CarrouselStoreService,
        protected breakpointObserver: BreakpointObserver,
        errorPageService: ErrorPageService,
        zone: NgZone,
        brandService: BrandService,
    ) {
        super(
            platformId,
            renderer,
            environmentService,
            elcosService,
            uaService,
            routerService,
            errorPageService,
            brandService,
        );
        this.addOutsideAngularRoutingHandler(zone, router);
    }

    public ngOnInit(): void {
        super.init();
        this.smartbannerStoreService.enter();
        this.carrouselStoreService.listenRouterEvents();
        this.navConfig$ = this.carrouselStoreService.getDisplayConfig$;
        EcmDispatcherModule.onShowMenuBar((showMenuBar: boolean) => {
            this.showMenuBar = showMenuBar;
        });
        this.trackPortfolioOnNavigationEnd(this.router, this.kenobiService);
        this.isXlScreen$ = this.breakpointObserver.observe(['(width >= 1200px)']).pipe(map(({ matches }) => matches));
    }
}
